import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "src/components/ui/button";
import { Textarea } from "src/components/ui/textarea";
import { useLanguage } from "src/context/LanguageContext";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../../components/ui/dialog";
import { Input } from "../../../components/ui/input";
import { SettingsData } from "../../../lib/languages";

export default function FAQDialog({
  open,
  onOpenChange,
  FAQData,
  onSave,
  saving,
  errors,
}) {
  const { language } = useLanguage();
  const t = SettingsData[language] || SettingsData["en"];

  const [formData, setFormData] = useState({
    question: "",
    answer: "",
    sort: null,
  });

  useEffect(() => {
    if (FAQData)
      setFormData({
        question: FAQData.question,
        answer: FAQData.answer,
        sort: FAQData.sort,
      });
  }, [FAQData]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[450px] max-h-[90vh] overflow-auto"
        dir={language === "en" ? "ltr" : "rtl"}
      >
        <DialogHeader>
          <DialogTitle>
            {FAQData?.id ? "Edit FAQ" : "Add FAQ"}
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="grid gap-4 py-4">
            {/* Question */}
            <div className="grid gap-2">
              <label htmlFor="question">Question</label>
              <Textarea
                id="question"
                name="question"
                value={formData.question}
                onChange={handleChange}
                placeholder="e.g., What is your return policy?"
                required
                rows={3}
              />
              {errors.question && (
                <p className="text-red-500 text-sm">{errors.question}</p>
              )}
            </div>
            {/* Answer */}
            <div className="grid gap-2">
              <label htmlFor="answer">Answer</label>
              <Textarea
                id="answer"
                name="answer"
                value={formData.answer}
                onChange={handleChange}
                placeholder="e.g., You can return any item within 30 days of purchase."
                required
                rows={4}
              />
              {errors.answer && (
                <p className="text-red-500 text-sm">{errors.answer}</p>
              )}
            </div>
            {/* Sort */}
            <div className="grid gap-2">
              <label htmlFor="sort">Sort</label>
              <Input
                id="sort"
                name="sort"
                type="number"
                value={formData.sort}
                onChange={handleChange}
                placeholder="e.g., 1"
                required
              />
              {errors.sort && (
                <p className="text-red-500 text-sm">{errors.sort}</p>
              )}
            </div>
          </div>
          <DialogFooter className={"flex gap-2 justify-between flex-wrap"}>
            <DialogClose>
              <Button
                type="button"
                variant="outline"
                className="w-full sm:w-fit"
              >
                Cancel
              </Button>
            </DialogClose>
            <Button type="submit" disabled={saving}>
              {saving && <Loader2 className="w-4 h-4 animate-spin" />}
              {t.save || "Save changes"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
